import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { IconDeprecated } from '../../misc/IconDeprecated/IconDeprecated';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { ModalWithBackdrop, ModalWithBackdropProps } from '../ModalWithBackdrop/ModalWithBackdrop';
import styles from './SelectModal.module.css';
export type SelectModalProps<T> = PropsWithoutChildren<ModalWithBackdropProps> & {
  readonly label: string;
  readonly items: Array<T>;
  readonly renderContentOfItem: (item: T) => React.JSX.Element;
  readonly getKeyOfItem: (item: T) => string;
  readonly onCloseButtonClick: () => void;
  readonly onItemSelected: (item: T) => void;
};
export const SelectModal = React.memo(props => {
  const $ = _c(37);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let getKeyOfItem;
  let items;
  let label;
  let onCloseButtonClick;
  let onItemSelected;
  let remainingProps;
  let renderContentOfItem;
  if ($[2] !== t0) {
    ({
      label,
      items,
      renderContentOfItem,
      getKeyOfItem,
      onCloseButtonClick,
      onItemSelected,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = getKeyOfItem;
    $[4] = items;
    $[5] = label;
    $[6] = onCloseButtonClick;
    $[7] = onItemSelected;
    $[8] = remainingProps;
    $[9] = renderContentOfItem;
  } else {
    getKeyOfItem = $[3];
    items = $[4];
    label = $[5];
    onCloseButtonClick = $[6];
    onItemSelected = $[7];
    remainingProps = $[8];
    renderContentOfItem = $[9];
  }
  let t1;
  if ($[10] !== getKeyOfItem || $[11] !== items || $[12] !== onItemSelected || $[13] !== renderContentOfItem) {
    let t2;
    if ($[15] !== getKeyOfItem || $[16] !== onItemSelected || $[17] !== renderContentOfItem) {
      t2 = item => <li key={getKeyOfItem(item)} className={styles.listItem} data-testid="SelectModal.ListItem" onClick={() => onItemSelected(item)}>{renderContentOfItem(item)}</li>;
      $[15] = getKeyOfItem;
      $[16] = onItemSelected;
      $[17] = renderContentOfItem;
      $[18] = t2;
    } else {
      t2 = $[18];
    }
    t1 = items.map(t2);
    $[10] = getKeyOfItem;
    $[11] = items;
    $[12] = onItemSelected;
    $[13] = renderContentOfItem;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  let t2;
  if ($[19] !== t1) {
    t2 = <>{t1}</>;
    $[19] = t1;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  const renderedItems = t2;
  let t3;
  if ($[21] !== label) {
    t3 = <div className={styles.label}>{label}</div>;
    $[21] = label;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  let t4;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconDeprecated name="times" />;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== onCloseButtonClick) {
    t5 = <button type="button" className={styles.closeButton} onClick={onCloseButtonClick} data-testid="SelectModal.CloseButton">{t4}</button>;
    $[24] = onCloseButtonClick;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== t3 || $[27] !== t5) {
    t6 = <header className={styles.header}>{t3}{t5}</header>;
    $[26] = t3;
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== renderedItems) {
    t7 = <ul>{renderedItems}</ul>;
    $[29] = renderedItems;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== t6 || $[32] !== t7) {
    t8 = <div className={styles.modal}>{t6}{t7}</div>;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== remainingProps || $[35] !== t8) {
    t9 = <ModalWithBackdrop {...remainingProps}>{t8}</ModalWithBackdrop>;
    $[34] = remainingProps;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  return t9;
}) as <T>(props: SelectModalProps<T>) => React.JSX.Element;